import { TownPage } from "./town-page";

export default function Wrentham() {
  return (
    <TownPage
      town="Wrentham"
      path="/service-areas/wrentham"
      headline="Property Care in Wrentham"
      description="TLC Associates LLC serves Wrentham's rural-character properties and spacious lots with wooded borders, stone walls, and open lawns. The community includes landscapes that need expert tree care, garden design, and seasonal management as well as regular lawn and bed maintenance. Larger lots often require selective work around mature trees and natural edges, while established homes and newer areas need dependable schedules that keep the grounds orderly. Spring cleanup, summer pruning, fall leaf removal, and winter access can be coordinated around the property. When a yard has become overgrown or its beds need a new direction, landscape renovation, planting, and stonework provide a practical way to improve the layout while retaining the property's existing character."
    />
  );
}